import { Link, Outlet, data } from "react-router";
// import { getSession } from "~/.server/supabase";
import { Route } from "./+types/route";

// export async function loader({ request }: Route.LoaderArgs) {
//   const { user, headers } = await getSession(request);
//   return data(
//     {
//       user,
//     },
//     {
//       headers,
//     },
//   );
// }

export default function App({ loaderData }: Route.ComponentProps) {
  // const { user } = loaderData;

  // const isLogged = user !== null;

  return (
    <div className="flex flex-col h-screen w-screen max-h-screen bg-base-200">
      <div className="navbar bg-base-100">
        <div className="indicator">
          <span className="indicator-item indicator-bottom badge badge-primary">
            beta
          </span>
          <Link to="/" className="btn btn-ghost text-xl">
            <div className="avatar">
              <div className="w-10 rounded-xl">
                <img src="/navbar-logo.png" />
              </div>
            </div>
            ReadType
          </Link>
        </div>
        <div className="flex-1"></div>
        <div className="flex-none">
          <div className="container mx-auto flex items-center px-4">
            {/* {isLogged ? (
              <p>
                {user?.email} {" | "} <Link to="/logout">Logout</Link>
              </p>
            ) : (
              <Link to="/login">Login</Link>
            )} */}
          </div>
        </div>
      </div>
      <div className="container mx-auto lg:h-full">
        <Outlet />
      </div>
    </div>
  );
}
